export default function getResource(label) {
    const resources = {
        free: 'Gratuit'
    };

    return resources[label];
}
